import React, { Component } from 'react';
import Dialog from '../../../../../commonModules/interface/Dialog';
import Photos from '../../../../../commonModules/interface/input-files';
import { isEmpty } from "lodash";
import { TextArea } from '../../../../../commonModules/interface/form-input-inline';
import { Button,Box } from '@material-ui/core';

class GlobalAnalys extends Component {
    state = { 
        errors:{
            comments: "",
        }
    }
   
    validate = () => {
        const required = ["comments"]
        let noErrors = true
        let errors = {}
        required.map( field => {
            if (this.props[field] === "" ){
                errors[field] = "Veuillez remplir ce champ"
                noErrors = false
            } else {
                errors[field] = ""
            }
                
        })
        
        this.setState({errors})
        if(noErrors){
            this.props.submitAll()            
        }
        
    }
    render() {
       
        return (
            <Dialog
                block={true}
                title="Analyse globale du produit"
                submitAction={ this.validate }
                submitTitle="Valider" 
                close={this.props.closeForms}
            >
                <Box>
                    <TextArea
                        className="form-control auto-size" 
                        placeholder="Achat de piéce, test technique ..." 
                        rows={4}
                        required
                        value={this.state.comments} 
                        name="comments" 
                        onChange={this.props.handleChange}
                        title="Description"
                    />
                    
                    <Box p={1} >
                        {/* <h5> <span>Joindre Fichier(s)</span> </h5> */}
                        <Photos photoList={this.props.setFiles} photos={this.props.files === null ? [] : this.props.files } file />
                    </Box>
                
                    {/* <Button variant="contained" color="secondary" onClick={this.validate}>Envoyer</Button> */}
                </Box>

            </Dialog>
        );
    }
}

export default GlobalAnalys;
